import t from "./index151.js";
/* empty css         */
import e from "./index130.js";
const a = /* @__PURE__ */ e(t, [["__scopeId", "data-v-7b646077"]]);
export {
  a as default
};
